import React, { useState, useEffect, useRef } from "react";
import { Modal, Spin } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { getRecaptchToken } from "../../api";

type Props = {
  visible: Boolean,
  setVisible: Function,
  onVerified: Function,
};

const RecaptchaModal = (props: Props) => {
  const { visible, onVerified } = props;
  const [siteKey, setSiteKey] = useState(null);
  const [loading, setLoading] = useState(true);
  const recaptchaRef = useRef(null);

  useEffect(() => {
    // Fetch site key dynamically from backend
    const fetchSiteKey = async () => {
      try {
        const entity = await getRecaptchToken();
        setSiteKey(entity?.siteKey);
      } catch (err) {
        console.error("Error fetching site key", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSiteKey();
  }, []);

  useEffect(() => {
    if (visible && recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [visible]);

  const handleCaptcha = (token) => {
    if (token) {
      onVerified(token);
    }
  };

  return (
    <Modal
      visible={visible}
      title="Verify You're Human"
      closable={false}
      footer={null}
      maskClosable={false}
    >
      {loading ? (
        <Spin />
      ) : (
        siteKey && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 120,
            }}
          >
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={siteKey}
              onChange={handleCaptcha}
            />
          </div>
        )
      )}
    </Modal>
  );
};

export default RecaptchaModal;
